/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable import/prefer-default-export */
import { createSelector } from '@reduxjs/toolkit';
import { SLICE } from 'modules/dashboard/constants';
import { initialState } from './slice';
//
const selectDomain = (state) => state[SLICE.CONFIGURE_EVENT_CATEGORIES] || initialState;
/**
 * Getting the loading state
 */
export const selectLoader = createSelector(
  [selectDomain],
  (configureEventCategoryState) => configureEventCategoryState.loading
);
/**
 * Retrieving the major event categories
 */
export const selectEventCategoryConfigurations = createSelector(
  [selectDomain],
  (configureEventCategoryState) => configureEventCategoryState.eventCategories
);
/**
 * Retrieving the minor event categories of a major event
 */
export const selectMinorEventCategories = createSelector(
  [selectDomain],
  (configureEventCategoryState) => configureEventCategoryState.minorEventCategories
);
/**
 * Getting the updated minor event state into the component
 */
export const selectMinorEventUpdateState = createSelector(
  [selectDomain],
  (configureEventCategoryState) => configureEventCategoryState.updatedMinorEvent
);
/**
 * Getting the hotel Id state into the component
 */
export const selectHotelId = createSelector(
  [selectDomain],
  (configureEventCategoryState) => configureEventCategoryState.hotelId
);
